import React, { useState } from "react";
import * as Yup from "yup";
import { Formik, Form, Field } from "formik";
import AuthInput from "../../../shared/authinput";
import MainButton from "../../../shared/Button";
import { styled } from "@mui/material/styles";
import { Container } from "@mui/material";
import CardUi from "./CardUi";
import borderBack from "../../../../assets/images/borderBack.png";
import { Link } from "react-router-dom";
import HorizontalLine from "../../../shared/HorizontalLine";

const EditCardMian = styled("div")(({ theme }) => ({
  [theme.breakpoints.down("sm")]: {
    paddingTop: "40px",
  },
  [theme.breakpoints.down("md")]: {
    paddingTop: "40px",
  },
  [theme.breakpoints.up("lg")]: {
    paddingTop: "40px",
  },
}));

const EditCardMianWrap = styled("div")(({ theme }) => ({
  width: "70%",
  margin: "0 auto",
  [theme.breakpoints.down("sm")]: {
    width: "100%",
  },
  [theme.breakpoints.down("md")]: {
    width: "100%",
  },
  [theme.breakpoints.up("lg")]: {
    width: "50%",
  },
}));

const Header = styled("div")(({ theme }) => ({ display: "flex", gap: "20px" }));
const Linked = styled(Link)(({ theme }) => ({ height: "50px" }));
const Maincontant = styled("div")(({ theme }) => ({
  "& h6": {
    ...theme.authTitle,
    paddingTop: "8px",
  },
}));
const Cardcontant = styled("div")(({ theme }) => ({
  marginTop: "20px",
  "& a": {
    width: "100%",
    textDecoration: "none",
  },
  "& .card_layout": {
    width: "50%",
    marginBottom: "20px",
    "& .css-1hcxvu3": {
      background: "#323232",
      marginTop: "10px",
      border: "none",
    },
    "& .css-jig3ky": { color: "#fff" },
    "& .css-1dpcftw": { color: "#fff" },
    "& .css-14ymhck": { color: "#fff" },
    "& .css-1ti503y .date span": { color: "#fff" },
    [theme.breakpoints.down("md")]: {
      width: "100%",
      marginBottom: "10px",
    },
  },
}));
const CardDateMain = styled("div")(({ theme }) => ({
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  flexDirection: "row",
  gap: "15px",
  "& .AuthInputMain:first-child": {
    width: "50%",
  },
  "& .AuthInputMain:last-child": {
    width: "50%",
  },
  [theme.breakpoints.down("md")]: {
    flexDirection: "column",
    gap: "1px",
    width: "100%",
    "& .AuthInputMain": {
      width: "100%",
    },
    "& .AuthInputMain:first-child": {
      width: "100%",
    },
    "& .AuthInputMain:last-child": {
      width: "100%",
    },
  },
}));
const FormMain = styled("div")(({ theme }) => ({
  marginBottom: "70px",
}));

const EditCard = () => {
  const [cardNumber, setCardNumber] = useState("");
  const [cardName, setcardName] = useState("");
  const [expirationDate, setexpirationDate] = useState("");

  const validationSchema = Yup.object().shape({
    CardNumber: Yup.string()
      .matches(/^\d{16}$/, "Must be a 16-digit number")
      .required("Enter your card number")
      .max(16, "Must be exactly 16 digits"),
    CardName: Yup.string().required("Enter Card Name your name"),
    ExpirationDate: Yup.string()
      .matches(
        /^(0[1-9]|1[0-2])\/?([0-9]{4}|[0-9]{2})$/,
        "Must be in the format of MM/YY or MM/YYYY"
      )
      .required("Enter expiration date"),
    CVV: Yup.string()
      .matches(/^\d{3,4}$/, "Must be a 3 or 4-digit number")
      .required("Enter CVV"),
  });
  return (
    <>
      <EditCardMian>
        <Container maxWidth="lg">
          <EditCardMianWrap>
            <Header>
              <Linked to="/profile">
                <img src={borderBack} alt="Linkarrow" />
              </Linked>
              <Maincontant>
                <h6>Edit Card</h6>
              </Maincontant>
            </Header>
            <Cardcontant>
              <CardUi />
            </Cardcontant>
            <HorizontalLine />
            <FormMain>
              <Formik
                initialValues={{
                  CardNumber: "",
                  CardName: "",
                  ExpirationDate: "",
                  CVV: "",
                }}
                validationSchema={validationSchema}
                onSubmit={(values) => {
                  // handle form submission here
                  console.log("values", values);
                }}
              >
                {(formik) => (
                  <Form autocomplete="off">
                    <CardDateMain>
                      <Field
                        type="number"
                        name="CardNumber"
                        label="Card Number"
                        component={AuthInput}
                        placeholder="Enter your card number"
                        onChange={(e) => {
                          const { value } = e.target;
                          if (value.length <= 16) {
                            formik.handleChange(e);
                            setCardNumber(value);
                          }
                        }}
                        value={formik.values.CardNumber}
                      />
                      <Field
                        type="text"
                        name="CardName"
                        label="Name On Card"
                        component={AuthInput}
                        placeholder="Enter your name"
                        onChange={(e) => {
                          const { value } = e.target;
                          formik.handleChange(e);
                          setcardName(value);
                        }}
                        value={formik.values.CardName}
                      />
                    </CardDateMain>
                    <CardDateMain>
                      <Field
                        type="text"
                        name="ExpirationDate"
                        label="Expiration Date"
                        component={AuthInput}
                        placeholder="MM/YYYY"
                        onChange={(e) => {
                          const { value } = e.target;
                          formik.handleChange(e);
                          setexpirationDate(value);
                        }}
                        value={formik.values.ExpirationDate}
                      />
                      <Field
                        type="text"
                        name="CVV"
                        label="CVV"
                        component={AuthInput}
                        placeholder="Cvv Code"
                      />
                    </CardDateMain>

                    <MainButton type="submit" label="Update Card" MT="70" />
                  </Form>
                )}
              </Formik>
            </FormMain>
          </EditCardMianWrap>
        </Container>
      </EditCardMian>
    </>
  );
};

export default EditCard;
